import { FC } from 'react';
import { LoaderType, NextgenImage, useBreakpoint } from '@nextgen-web-framework/all';
import RichTextComponent from '../AboutAmway/RichTextComponent/RichTextComponent';
import type { BannerRichTextProps } from './types/propsTypes';
import styles from './BannerRichText.module.scss';

const BannerRichText: FC<BannerRichTextProps> = (props) => {
  const viewPortType = useBreakpoint();
  const image = props?.images.find((image) => image?.viewport.includes(viewPortType));
  return (
    <div className={styles['banner-rich-text-container']} data-testid={'banner-rich-text-container-test-id'}>
      <h2 className={styles['banner-title']}>{props.title}</h2>
      <div className={styles['img-container']}>
        <NextgenImage
          loaderType={LoaderType.CONTENTSTACK}
          src={image?.url ?? ''}
          className={styles['banner-rich-text-image']}
          alt={image?.altText ?? ''}
        />
      </div>
      <div>
        <RichTextComponent
          {...props.richTextComponentData}
          sanitize={props.sanitize}
          sanitizationConfig={props.sanitizationConfig}
        />
      </div>
    </div>
  );
};

export default BannerRichText;
export type { BannerRichTextProps };
